import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { postApiCall } from "./tokenService";

export const saveFilter = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/filter/save", SaveSuccess, JSON.stringify(obj));
};

export const removeFilter = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/filter/remove", ApiSuccess, JSON.stringify(obj));
};